import { CounterpartyLimitViewModel, TradingCounterpartyLegalHierarchyOwnership } from './CounterpartyLimits.component.model'
import { ExchangeRateEF, TradingEntityLegalHierarchyOwnership } from '../../../../limit-management/TradingLimits.model';
import { ConsoleLoggerService } from '../../../../common/LoggerService/console-logger.service';
import { UtilityService } from '../../../../common/utility.service';
import { CounterpartyLimitsCommonManager } from '../CounterpartyLimits/CounterpartyLimits.common';
import { Constants } from "../../../../common/constants"

//@Injectable()
export class CounterpartyLimitsManager {
  __iCptysUnderHierarchy: number[] = [];
  __oDataSource: CounterpartyLimitViewModel[] = [];
  __trvInstance: any = {};
  __sMessage: string = "";
  __oLogger: ConsoleLoggerService;
  constructor(oLogger: ConsoleLoggerService) {
    this.__oLogger = oLogger;
  }
  //update all warnings for commodities
  updateWarningsForCommodity(bSidebarApply: boolean, oDatasource: CounterpartyLimitViewModel[], oSystemSettings: any, oExchangeRateEFs: ExchangeRateEF[], otrCounterpartyLimits: any, oTradingCounterpartyLegalHierarchyOwnerships: TradingCounterpartyLegalHierarchyOwnership[], __oUtilityService: UtilityService): CounterpartyLimitViewModel[] {
    try {
      let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(oDatasource, otrCounterpartyLimits, this.__oLogger);
      let oCounterpartyLimitDatas = oSystemSettings[0].IsCounterPartyLimitValidated === 1 ? oDatasource.filter(z => z.IsOverall === 1) : (oSystemSettings[0].IsCounterPartyLimitValidated === 2 ? oDatasource.filter(z => z.IsOverall === 1 && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId === z.lTradingCounterpartyId) : [])

      oCounterpartyLimitDatas.filter(z => z.IsOverall === 1).forEach(data => {
        data.Warnings = [];

        this.__iCptysUnderHierarchy = [];
        let oItem: any = {};
        oItem.TradingCounterpartyLegalHierarchyOwnershippings = [];
        oItem.TradingCounterpartyLegalHierarchyOwnershippings.push(oTradingCounterpartyLegalHierarchyOwnerships[0]);
        this.normalize(oItem, data.lTradingCounterpartyId, oSystemSettings[0].IsCounterPartyLimitValidated === 1 ? true : false);

        var oTempDataSource = oDatasource.filter(x => x.IsOverall === 1 && this.__iCptysUnderHierarchy.indexOf(x.lTradingCounterpartyId) !== -1 && x.lOurEntityId == data.lOurEntityId &&
          x.lLimitTypeId == data.lLimitTypeId && x.lSubLimitTypeId == data.lSubLimitTypeId && x.lCounterpartyLimitId !== data.lCounterpartyLimitId && x.lTradingCategoryId === data.lTradingCategoryId);//FB43985-Pawan Prajapati

        for (let i = (oSystemSettings[0].CounterpartyLimitMaxTenure - 1); i >= 0; i--) {//CRD-420-Pawan Prajapati
          let iSum = 0;
          oTempDataSource.forEach(x => {
            if (x.DataValues[i].LimitValue) {
              iSum = (data ? (iSum + (oCounterpartyLimitsCommonManager.currencyConversion(x.DataValues[i].LimitValue, x.lLimitValueCurrencyId, data.lLimitValueCurrencyId, oExchangeRateEFs))) : (iSum + x.DataValues[i].LimitValue)); //iSum + x.DataValues[i].LimitValue;
            }
          });

          if (data && data.DataValues[i] && data.DataValues[i].LimitValue < iSum) {
            data.DataValues[i].IsCommodityOverAllocation = 1;

            let oWarning: any = {};
            oWarning.ColumnName = data.DataValues[i].ColumnName;
            oWarning.RowIndex = otrCounterpartyLimits.instance.getRowIndexByKey(data.lCounterpartyLimitId);
            oWarning.ColumnIndex = i;

            data.Warnings.push(oWarning);
            if (bSidebarApply) {
              oTempDataSource.forEach(x => {
                if (x.DataValues[i]) {
                  x.DataValues[i].IsCommodityOverAllocation = 1;
                }
              });
            }
          } else {
            data.DataValues[i].IsCommodityOverAllocation = 0;
            if (bSidebarApply) {
              oTempDataSource.forEach(x => {
                if (x.DataValues[i]) {
                  x.DataValues[i].IsCommodityOverAllocation = 0;
                }
              });
            }
          }
        }
      });
      return oDatasource;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing update Warnings For Commodity function.');
    }
  }
  //currency conversion to be done wrt overall limit currency
  currencyConversion(limitValue: any, fromCurrency: number, toCurrency: number, oExchangeRateEFs: ExchangeRateEF[]): number {
    try {
      let nReturn = limitValue;
      let nExchangeRate = 1;
      if (oExchangeRateEFs && oExchangeRateEFs.length > 0 && oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency)) {
        nExchangeRate = oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency).ConversionRate;
      }
      nReturn = Math.floor(limitValue * nExchangeRate);
      return nReturn;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing on Currency Conversion function.');
    }
  }
  ///drill down the hierarchy
  normalize(parent: any, nIdentifyCpty: number, bIsImmidiateParent: boolean) {
    try {
      if (parent && parent.TradingCounterpartyLegalHierarchyOwnershippings) {
        let IsItemFound: boolean = false;
        for (var i = 0, l = parent.TradingCounterpartyLegalHierarchyOwnershippings.length; i < l; ++i) {
          child = parent.TradingCounterpartyLegalHierarchyOwnershippings[i];
          if ((child.lChildTradingCounterpartyId == nIdentifyCpty)) {

            if (bIsImmidiateParent) {
              if (child.TradingCounterpartyLegalHierarchyOwnershippings && child.TradingCounterpartyLegalHierarchyOwnershippings.length > 0) {
                child.TradingCounterpartyLegalHierarchyOwnershippings.forEach(x => this.__iCptysUnderHierarchy.push(x.lChildTradingCounterpartyId));
              }
              break;
            };

            this.extractCptyFromHierarchy(child);
            if (this.__iCptysUnderHierarchy.filter(c => c == child.lChildTradingCounterpartyId).length == 0) {
              this.__iCptysUnderHierarchy.push(child.lChildTradingCounterpartyId);
            }

          }
          var child = parent.TradingCounterpartyLegalHierarchyOwnershippings[i];
          this.normalize(child, nIdentifyCpty, false);
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing normalize function.');
    }
  }
  //gets all counterparties under a node
  extractCptyFromHierarchy(parent: any) {
    try {
      if (parent && parent.TradingCounterpartyLegalHierarchyOwnershippings.length > 0) {
        for (var i = 0, l = parent.TradingCounterpartyLegalHierarchyOwnershippings.length; i < l; ++i) {
          var child = parent.TradingCounterpartyLegalHierarchyOwnershippings[i];
          if (this.__iCptysUnderHierarchy.filter(x => x == child.lChildTradingCounterpartyId).length == 0) {
            this.__iCptysUnderHierarchy.push(child.lChildTradingCounterpartyId);
          }
          this.extractCptyFromHierarchy(child);
        }
      }
      else if (parent) {
        if (this.__iCptysUnderHierarchy.filter(x => x == parent.lChildTradingCounterpartyId).length == 0) {
          this.__iCptysUnderHierarchy.push(parent.lChildTradingCounterpartyId);
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing extractCptyFromHierarchy function.');
    }
  }
  //validations on limits
  validateLimit(bValidated: boolean, oDatasource: CounterpartyLimitViewModel[], oSystemSettings: any, oExchangeRateEFs: ExchangeRateEF[], otrCounterpartyLimits: any, oTradingCounterpartyLegalHierarchyOwnerships: TradingCounterpartyLegalHierarchyOwnership[], __oUtilityService: UtilityService, oTradingEntityLegalHierarchyOwnerships: TradingEntityLegalHierarchyOwnership[]): any {
    try {
      let sMessage: string = "";
      this.__oDataSource = oDatasource;
      this.__trvInstance = otrCounterpartyLimits;
      let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(this.__oDataSource, otrCounterpartyLimits, this.__oLogger);
      if (oSystemSettings[0].IsOverAllLimitValidated) {

        oDatasource.filter(z => z.TradingCategoryName !== "Overall" && z.TradingCategoryName !== "Headroom" && z.lParentTradingCategoryId === 1).forEach(x => {
          let oLimit = oDatasource.find(z => z.TradingCounterpartyName == x.TradingCounterpartyName && z.TradingEntityName == x.TradingEntityName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
          if (!oLimit) {
            bValidated = false;
            sMessage = 'The Overall limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + " and Limit Type: " + x.LimitTypeName + ". Please add.";
          }
        });

        oDatasource.filter(z => z.TradingCategoryName !== "Overall" && z.TradingCategoryName !== "Headroom" && z.lParentTradingCategoryId !== 1).forEach(x => {
          let oLimit = oDatasource.find(z => z.TradingCounterpartyName == x.TradingCounterpartyName && z.TradingEntityName == x.TradingEntityName && z.LimitTypeName == x.LimitTypeName && z.lTradingCategoryId === x.lParentTradingCategoryId);//FB43985-Pawan Prajapati
          if (!oLimit) {
            bValidated = false;
            sMessage = 'The Trading Category limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + " and Limit Type: " + x.LimitTypeName + ". Please add.";
          }
        });

        if (bValidated && oDatasource.find(z => (z.TradingCategoryName === "Overall" || z.IsOverall === 1 || z.TradingCategoryName === "Headroom") && z.Warnings && z.Warnings.length > 0)) {
          bValidated = false;
          if (oDatasource.find(z => (z.TradingCategoryName === "Overall" || z.IsOverall === 1 || z.TradingCategoryName === "Headroom") && z.Warnings && z.Warnings.length > 0).TradingCategoryName === 'Headroom') {
            sMessage = Constants.THE_OVERALL_LIMIT_EXCEEDS_HEADROOM_LIMIT;
          }
          else {
            sMessage = Constants.THE_SUMOF_SUBLIMITS_EXCEEDS_OVERALL_LIMIT;
          }
        }
      }

      if (oSystemSettings[0].IsCounterPartyLimitValidated === 1 && oSystemSettings[0].IsEntityLimitValidated === 2 && bValidated) {

        let oTreeDatasource = oCounterpartyLimitsCommonManager.buildtree(JSON.parse(JSON.stringify(oDatasource)), oTradingEntityLegalHierarchyOwnerships, oTradingCounterpartyLegalHierarchyOwnerships);//oCounterpartyLimitsCommonManager.buildtree(JSON.parse(JSON.stringify(oDatasource));

        if (bValidated) {
          oTreeDatasource.filter(z => z.TradingCategoryName === "Overall").forEach(x => {
            this.__iCptysUnderHierarchy = [];
            if (x.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId) {

            }
            else {
              let oParentLimit = oTreeDatasource.find(z => z.lCounterpartyLimitId == x.lParentCounterpartyLimitId);
              let oUltimateParent = oTreeDatasource.filter(y => y.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && y.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && y.LimitTypeName == x.LimitTypeName && y.lSubLimitTypeId == x.lSubLimitTypeId);//FB44260-Pawan Prajapati
              if (bValidated && !oParentLimit && oUltimateParent && oUltimateParent.length > 0) {
                bValidated = false;
                sMessage = 'The Overall limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + ", Limit Type: " + x.LimitTypeName + " and Trading Category: " + x.TradingCategoryName + ". Please add.";
              }
            }
          });
        }

        if (bValidated) {
          oTreeDatasource.filter(z => z.IsOverall === 1).forEach(x => {
            this.__iCptysUnderHierarchy = [];
            if (x.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId) {

            }
            else {
              let oParentLimit = oTreeDatasource.find(z => z.lCounterpartyLimitId == x.lCommodityParentCounterpartyLimitId);
              let oUltimateParent = oTreeDatasource.filter(y => y.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && y.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && y.LimitTypeName == x.LimitTypeName && y.lSubLimitTypeId == x.lSubLimitTypeId && y.IsOverall === 1);//FB44260-Pawan Prajapati
              if (bValidated && !oParentLimit && oUltimateParent && oUltimateParent.length > 0) {
                bValidated = false;
                sMessage = 'The Overall limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + ", Limit Type: " + x.LimitTypeName + " and Trading Category: " + x.TradingCategoryName + ". Please add.";
              }
            }
          });
        }

        //IsOverall === 1
        if (bValidated) {
          oTreeDatasource.filter(z => z.TradingCategoryName === "Overall").forEach(x => {
            if (x.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId) {

            }
            else {
              this.__iCptysUnderHierarchy = [];
              let oParentLimit = oTreeDatasource.find(z => z.lCounterpartyLimitId == x.lParentCounterpartyLimitId);
              if (oParentLimit) {
                let oTempDataSource = oTreeDatasource.filter(z => z.lParentCounterpartyLimitId == oParentLimit.lCounterpartyLimitId && z.TradingCategoryName === "Overall");
                ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
              }
            }
          });
        }

        if (bValidated) {
          oTreeDatasource.filter(z => z.IsOverall === 1).forEach(x => {
            if (x.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId) {

            }
            else {
              this.__iCptysUnderHierarchy = [];
              let oParentLimit = oTreeDatasource.find(z => z.lCounterpartyLimitId == x.lCommodityParentCounterpartyLimitId);
              if (oParentLimit) {
                let oTempDataSource = oTreeDatasource.filter(z => z.lCommodityParentCounterpartyLimitId == oParentLimit.lCounterpartyLimitId && z.IsOverall === 1);
                ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
              }
            }
          });
        }

        this.__oDataSource.forEach(x => {
          x.CounterpartyLimitWarnings = oTreeDatasource.filter(z => z.lCounterpartyLimitId == x.lCounterpartyLimitId)[0].CounterpartyLimitWarnings;
        });

        this.__oDataSource.filter(x => x.CounterpartyLimitWarnings && x.CounterpartyLimitWarnings.length > 0).length > 0 ? bValidated = false : "";

      }

      if (oSystemSettings[0].IsCounterPartyLimitValidated === 1 && oSystemSettings[0].IsEntityLimitValidated !== 2 && bValidated) {

        oDatasource.filter(z => z.IsOverall === 1 && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId !== z.lTradingCounterpartyId).forEach(x => {
          let oParentLimit = oDatasource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.TradingCategoryName == x.TradingCategoryName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati
          if (bValidated && !oParentLimit && x.lParentTradingCounterpartyId > 0 && x.IsOverall == 1) { //FB42947-Pawan Prajapati
            bValidated = false;
            sMessage = 'The Trading Category limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + ", Limit Type: " + x.LimitTypeName + " and Trading Category: " + x.TradingCategoryName + ". Please add.";
          }
        });

        //commodity validations wrt immidiate parent
        if (bValidated) {
          oDatasource.filter(z => z.IsOverall === 1 && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId !== z.lTradingCounterpartyId).forEach(x => {
            this.__iCptysUnderHierarchy = [];
            let oParentLimit = oDatasource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.TradingCategoryName == x.TradingCategoryName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB44260,FB43985-Pawan Prajapati
            this.normalize(oTradingCounterpartyLegalHierarchyOwnerships[0], x.lParentTradingCounterpartyId, true);

            let oTempDataSource = oDatasource.filter(z => this.__iCptysUnderHierarchy.indexOf(z.lTradingCounterpartyId) !== -1 && z.lTradingCounterpartyId != oParentLimit.lTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1 && z.lTradingCategoryId == oParentLimit.lTradingCategoryId);//FB44260,FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
          oDatasource.filter(z => z.IsOverall === 1 && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId == z.lTradingCounterpartyId).forEach(x => {
            this.__iCptysUnderHierarchy = [];
            let oParentLimit = x;
            var oItem: any = oTradingCounterpartyLegalHierarchyOwnerships[0];
            oItem.TradingCounterpartyLegalHierarchyOwnershippings.forEach(c => this.__iCptysUnderHierarchy.push(c.lChildTradingCounterpartyId));
            let oTempDataSource = oDatasource.filter(z => this.__iCptysUnderHierarchy.indexOf(z.lTradingCounterpartyId) !== -1 && z.lTradingCounterpartyId != oParentLimit.lTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1 && z.lTradingCategoryId == oParentLimit.lTradingCategoryId);//FB44260,FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
          //}
        }
        if (bValidated) {
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId !== z.lTradingCounterpartyId).forEach(x => {
            this.__iCptysUnderHierarchy = [];
            let oParentLimit = oDatasource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB44260,FB43985-Pawan Prajapati
            if (bValidated && !oParentLimit && x.lParentTradingCounterpartyId > 0 && x.TradingCategoryName === "Overall") { //FB42947-Pawan Prajapati
              bValidated = false;
              sMessage = 'The Overall limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + ", Limit Type: " + x.LimitTypeName + " and Trading Category: " + x.TradingCategoryName + ". Please add.";
            }
          });
        }

        if (bValidated) {
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId !== z.lTradingCounterpartyId).forEach(x => {
            this.__iCptysUnderHierarchy = [];
            let oParentLimit = oDatasource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB44260,FB43985-Pawan Prajapati
            this.normalize(oTradingCounterpartyLegalHierarchyOwnerships[0], x.lParentTradingCounterpartyId, true);
            let oTempDataSource = oDatasource.filter(z => this.__iCptysUnderHierarchy.indexOf(z.lTradingCounterpartyId) !== -1 && z.lTradingCounterpartyId != oParentLimit.lTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB44260,FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId == z.lTradingCounterpartyId).forEach(x => {
            this.__iCptysUnderHierarchy = [];
            let oParentLimit = x;
            var oItem: any = oTradingCounterpartyLegalHierarchyOwnerships[0];
            oItem.TradingCounterpartyLegalHierarchyOwnershippings?.forEach(c => this.__iCptysUnderHierarchy.push(c.lChildTradingCounterpartyId));
            let oTempDataSource = oDatasource.filter(z => this.__iCptysUnderHierarchy.indexOf(z.lTradingCounterpartyId) !== -1 && z.lTradingCounterpartyId != oParentLimit.lTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB44260,FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
        }

        this.__oDataSource.filter(x => x.CounterpartyLimitWarnings && x.CounterpartyLimitWarnings.length > 0).length > 0 ? bValidated = false : "";
      }

      if (oSystemSettings[0].IsCounterPartyLimitValidated === 2 && bValidated) {

        if (bValidated) {
          oDatasource.filter(z => z.IsOverall === 1 && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId !== z.lTradingCounterpartyId).forEach(x => {
            let oUltimateParentLimit = oDatasource.find(z => z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB44260,FB43985-Pawan Prajapati
            if (oUltimateParentLimit) {
              let oTempDataSource = oDatasource.filter(z => z.lCounterpartyLimitId != oUltimateParentLimit.lCounterpartyLimitId && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1 && z.lTradingCategoryId == oUltimateParentLimit.lTradingCategoryId);//&& z.TradingEntityName == x.TradingEntityName //FB44260,FB43985-Pawan Prajapati
              ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oUltimateParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
            }
          });
        }


        if (bValidated) {
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId !== z.lTradingCounterpartyId).forEach(x => {
            let oUltimateParentLimit = oDatasource.find(z => z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall"); //FB44260,FB43985-Pawan Prajapati
            if (oUltimateParentLimit) {
              let oTempDataSource = oDatasource.filter(z => z.lCounterpartyLimitId != oUltimateParentLimit.lCounterpartyLimitId && z.lSubLimitTypeId === x.lSubLimitTypeId && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//&& z.TradingEntityName == x.TradingEntityName //FB44260,FB43985-Pawan Prajapati
              ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oUltimateParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
            }
          });
        }

        this.__oDataSource.filter(x => x.CounterpartyLimitWarnings && x.CounterpartyLimitWarnings.length > 0).length > 0 ? bValidated = false : "";
      }
      this.__sMessage = sMessage;
    }
    catch (e) {
      this.__oLogger.Write(e, 'Error', 'Error occurred during validating data source.');
    }

    let __oSource: any = {}
    __oSource.bValidated = bValidated;
    __oSource.__oDatasource = this.__oDataSource;
    __oSource.sMessage = this.__sMessage;

    return __oSource;
  }
}
